import React from "react";

// import { PeopleFill, Search } from "react-bootstrap-icons";

// import { useTranslation } from "react-i18next";

/**
 * 
 * @param param0 
 * @returns 
 */
const NoHouse = ({fromSearch = false}) => {

    // const { t } = useTranslation();

    return (
        <div className="no-house">
            <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex flex-column align-items-center justify-content-center mt-12 gap-3">
                {
                    fromSearch
                    ?
                    <div className="icon-wrapper">
                        <i className="fas fa-search"></i>
                    </div>
                    :
                    <div className="icon-wrapper text-muted">
                        {/* <PeopleFill size={64} /> */}
                        <i className="fas fa-search"></i>
                    </div>
                }
                    <p className="no-house-text text-center mb-0 fs-8">{!fromSearch ? 'Aucune maison disponible pour le moment' : 'Aucune maison trouvé pour votre recherche'}</p>
                </div>
            </div>
        </div>
    );
};

export default NoHouse;
